import { StatusCodes } from "http-status-codes"
import { LOGIN_ENDPOINT } from "../helpers/authUtils"

export const isInternalServerError = (error: any) => {
	return error.response?.status === StatusCodes.INTERNAL_SERVER_ERROR
}

export const isBadRequest = (error: any) => {
	return error.response?.status === StatusCodes.BAD_REQUEST
}

export const isForbidden = (error: any) => {
	return error.response?.status === StatusCodes.FORBIDDEN
}

export const isUnauthorized = (error: any) => {
	return error.response?.status === StatusCodes.UNAUTHORIZED
}

export const isUnauthorizedOrForbidden = (error: any) => {
	return isUnauthorized(error) || isForbidden(error)
}

export const isLoginAttempt = (error: any) => {
	return error.config.url.includes(LOGIN_ENDPOINT)
}

export const parseJSONorDefault = (data: string) => {
	try {
		return JSON.parse(data)
	} catch (e) {
		return data
	}
}

export interface RequestStopper {
	cancel: (msg: string) => void
	token: any
}
